import axios from 'axios';
import { initialize } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import { BASE_API, COMPANY_WEBSITE_SUBSCRIPTION_PLANS, USER_TOKEN } from 'config/consts';
import moment from 'moment';

//rotas de transaçoes da api
const URL_USER_CEP = `${BASE_API}/get-address-zip-code`;
const URL_CREDIT_CARDS = `${BASE_API}/user-credit-cards`;
const URL_USER_ACTION_SUBSCRIPTIONS = `${BASE_API}/user-subscribed-action`;
const URL_LAST_ACTION_SUBSCRIPTION_USER = `${BASE_API}/last-action-subscription`;
const URL_CANCEL_USER_SUBSCRIBED_ACTION = `${BASE_API}/cancel-user-subscribed-action`;

export const getUserActionSubscriptions = (actionId) => {
  const url = actionId
    ? `${URL_USER_ACTION_SUBSCRIPTIONS}?where[action_id]=${actionId}`
    : URL_USER_ACTION_SUBSCRIPTIONS;
  return (dispatch) => {
    dispatch([
      {
        type: 'USER_ACTION_SUBSCRIPTIONS_LOAD',
        payload: true,
      },
    ]);
    axios
      .get(url, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        response.data.forEach(item => { // complexidade | temporal O(n), espacial O(1)
          item.actionId = item.action_subscription.action_id;
          item.priceFormatted = `R$ ${parseFloat(item.price).toFixed(2).replace('.', ',')}`;
          item.paidFormatted = `${item.paid ? 'Pago' : 'Pendente'}`;
          item.recurrenceFormatted = `${COMPANY_WEBSITE_SUBSCRIPTION_PLANS[item.action_subscription.recurrence]}`;
          item.vigencia = `${moment(item.createdAt).format('DD/MM/YYYY')} até ${moment(item.expiration).format('DD/MM/YYYY')}`;
        });
        dispatch([
          {
            type: 'USER_ACTION_SUBSCRIPTIONS_FETCHED',
            payload: response.data,
          },
        ]);
      })
      .catch((e) => console.log('Erro ao recuperar info: ', e.message));
  };
};

export const getLastActionSubscriptionByCurrentUser = (actionId) => {
  return (dispatch) => {
    dispatch([
      {
        type: 'LAST_USER_ACTION_SUBSCRIPTION_LOAD',
        payload: true,
      },
    ]);
    axios
      .get(`${URL_LAST_ACTION_SUBSCRIPTION_USER}?where[action_id]=${actionId}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'LAST_USER_ACTION_SUBSCRIPTION_FETCHED',
            payload: response.data,
          },
        ]);
      })
      .catch((e) => console.log('Erro ao recuperar info: ', e.message));
  };
};

export const initializeForm = (values) => {
  return initialize('creditCardSubscriptionActionForm', values);
};

export const getUserAddress = (values, oldValues) => {
  return (dispatch) => {
    dispatch(
      initializeForm({
        ...oldValues,
        city: `Carregando...`,
        street: `Carregando...`,
      })
    );
    axios
      .post(`${URL_USER_CEP}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch(
          initializeForm({
            ...oldValues,
            payment: {
              ...oldValues.payment,
              ...response.data,
            },
          })
        );
      })
      .catch((e) => {
        dispatch(
          initializeForm({
            ...oldValues,
            payment: {
              ...oldValues.payment,
              city: 'CEP inválido',
              street: 'CEP inválido',
            },
          })
        );
      });
  };
};

export const createCreditCard = ({ payment }) => {
  return (dispatch) => {
    dispatch([{
      type: 'CARD_USER_SUBSCRIPTION_ACTION_LOADING',
      payload: true,
    }]);
    axios
      .post(`${URL_CREDIT_CARDS}`, payment, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        toastr.success('Sucesso', 'Cartão salvo com sucesso');
        dispatch([{
          type: 'CARD_USER_SUBSCRIPTION_ACTION_LOADING',
          payload: false,
        }]);
        setTimeout(() => { window.location.reload() }, 1000);
      })
      .catch((e) => {
        try {
          if (e.response.data.errorValidate) {
            toastr.error('Erro', e.response.data.errorValidate);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro interno no servidor');
        }
      });
  };
};

export const cancelUserActionSubscriptionByActionId = (action_id) => {
  return (dispatch) => {
    dispatch([{
      type: 'CANCEL_USER_SUBSCRIPTION_ACTION_LOADING',
      payload: true,
    }]);
    axios
      .post(`${URL_CANCEL_USER_SUBSCRIBED_ACTION}/${action_id}`, { action_id }, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        toastr.success('Sucesso', 'Cancelamento de assinatura realizado com sucesso');
        dispatch([{
          type: 'CANCEL_USER_SUBSCRIPTION_ACTION_LOADING',
          payload: false,
        }]);
        setTimeout(() => { window.location.reload() }, 1000);
      })
      .catch((e) => {
        toastr.error('Erro', 'Erro ao cancelar assinatura');
      });
  };
};
